module.exports = __webpack_public_path__ + "img/S2M3.ad154dfd.jpg";